
function setupServicesAccordion()
{
  let servicesPopupContent = $(['data-popup-content="services"'])

  if(!servicesPopupContent.length) { return false }

  let $body = $('body')
  let popupAccordion = '.popup[data-content="services"]'
  let accordionRows = '[data-services-row]'
  let accordionContentRows = `${popupAccordion} .services-accordion .accordion-content`

  $body.on('click', '.c-link[data-js-open-popup-content="services"]', function (e){
    e.preventDefault()
    $(accordionRows).removeClass('is-opened')
    $(`${popupAccordion} .services-accordion .accordion-content`).each(function (){
      $(this).attr('data-height', `${$(this).height()}px`).css('height', 0).addClass('is-animating')
    })
  })

  $body.on('click', '.js-services-accordion', function (e){
    e.preventDefault()
    let $this = $(this)
    let accordionRowID = $this.attr('data-services-row')

    if(!$this.hasClass('is-opened')) {

      $(accordionRows).removeClass('is-opened')
      $(accordionContentRows).css('height', '0px')
      $(`[data-services-row="${accordionRowID}"]`).addClass('is-opened')

      let accordionRowContent = $(`${accordionContentRows}[data-services-row="${accordionRowID}"]`)
      accordionRowContent.css('height', accordionRowContent.attr('data-height'))

    } else {
      $(accordionRows).removeClass('is-opened')
      $(accordionContentRows).css('height', '0px')
    }


  })

}

setupServicesAccordion()
